<template>
    <FormRoot>
        <Field
            :form.sync="form"
            type="text"
            name="group.external_id"
            placeholder="External ID"
            hint="External ID of the user"
        />
        <Field
            :form.sync="form"
            type="text"
            name="group.weekly_working_hours"
            placeholder="Weekly working hours"
            hint="Weekly working hours of the user"
        />
        <Field
            :form.sync="form"
            type="date"
            name="group.start_date"
            placeholder="Start date"
            hint="Start date of the user"
            @input="clearDateErrors"
        />
        <Field
            :form.sync="form"
            type="date"
            name="group.exit_date"
            placeholder="Exit date"
            hint="Exit date of the user"
            @input="clearDateErrors"
        />
        <FormActions>
            <Submit class="float-right" :disabled="!form.submittable" @click="onSubmit">Update user in group</Submit>
        </FormActions>
    </FormRoot>
</template>

<script>
    import { FormRoot, Field, FormActions, Submit } from '@tech_hexeko/design-system'
    import Forms from '@/mixins/Forms'
    import Generator from '@/mixins/Generator'
    import moment from 'moment'

    export default {
        mixins: [Forms, Generator],
        components: {
            Field,
            FormActions,
            FormRoot,
            Submit,
        },
        data() {
            return {
                fields: {
                    group: {
                        exit_date: null,
                        start_date: null,
                        external_id: null,
                        weekly_working_hours: null,
                    },
                },
                messageSuccess: 'The user has been updated in the group',
            }
        },
        props: {
            group: {
                type: Object,
                required: true,
            },
            userId: {
                type: Number,
                required: true,
            },
        },
        methods: {
            submit() {
                if (this.group?.id && this.userId) {
                    return this.$api.groups.patchUser(this.group.id, this.userId, this.$data.form.data())
                }
            },
            clearDateErrors() {
                if (this.form.errors.has('group.start_date')) {
                    this.form.errors.clear('group.start_date')
                }
                if (this.form.errors.has('group.exit_date')) {
                    this.form.errors.clear('group.exit_date')
                }
            },
        },
        watch: {
            group: {
                handler(group) {
                    if (!group?.user_group) return
                    const { external_id, weekly_working_hours, exit_date, start_date } = group.user_group

                    this.fields.group.external_id = external_id ?? null
                    this.fields.group.weekly_working_hours = weekly_working_hours ?? null
                    this.fields.group.exit_date = exit_date ? moment(exit_date).format('YYYY-MM-DD') : null
                    this.fields.group.start_date = start_date ? moment(start_date).format('YYYY-MM-DD') : null
                },
                immediate: true,
            },
        },
    }
</script>
